import { render, staticRenderFns } from "./projectevents.vue?vue&type=template&id=f3d9451c&"
import script from "./projectevents.vue?vue&type=script&lang=js&"
export * from "./projectevents.vue?vue&type=script&lang=js&"
import style0 from "./projectevents.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports